import i18n from "../services/i18n"

/**
 * Достаёт из ошибки axios сообщение, понятное пользователю.
 *
 * Бэкенд отдаёт нарушение бизнес-правила как 400 с телом
 * { code: "THE_QUANTITY_OF_PRODUCTS_IS_NOT_ENOUGH", message: "…" }.
 * Раньше форма показывала одно и то же зашитое сообщение про нехватку
 * товара на любую ошибку — включая 401, 400 и сбой сервера, — поэтому
 * причина отказа оставалась неизвестной.
 */
export default function getErrorMessage(error: any, fallback?: string): string {
  const data = error?.response?.data

  if (typeof data === "string" && data.trim()) {
    return data
  }

  if (data) {
    // { code, message } — наш формат. Текст с сервера подробнее перевода
    // (называет товар, остаток и запрошенное количество), поэтому он в приоритете
    if (data.message) return String(data.message)
    if (data.code) {
      const translated = i18n.t(data.code)
      return translated && translated !== data.code ? translated : String(data.code)
    }
    // ValidationProblemDetails от ASP.NET: { errors: { field: [msg] } }
    if (data.errors && typeof data.errors === "object") {
      const first: any = Object.values(data.errors)[0]
      if (Array.isArray(first) && first.length) return String(first[0])
    }
    if (data.title) return String(data.title)
  }

  const status = error?.response?.status
  if (status === 401 || status === 403) {
    return i18n.t("unauthorizedMessage") || "Нет доступа. Войдите в систему заново."
  }

  return fallback || error?.message || "Неизвестная ошибка"
}
